import React/*, { setState }*/ from 'react';
import PropTypes from 'prop-types';
import { Redirect, Link } from 'react-router-dom';
//import { Popup } from '@progress/kendo-react-popup';
import { AppContext } from '../context/AppContext';
import { /*abc, */isSocialLogin, isEmpty } from '../helpers';
import Tooltip from './Tooltip';
import { DropDownList } from "@progress/kendo-react-dropdowns";
import moment from 'moment';
import { compose } from 'redux';
import hasData from '../hoc/hasData';

import localize from '../hoc/localize';
const languages = ['en', 'fr']

class Header extends React.Component {
    //anchor = null;

    constructor(props) {
        super(props);
        this.state = {
            isChangingPassword: false,
            showProfile: false,
            showMinimizedProfile: false,
            selectedProfile: 'deselected',
            fontSize: '24px',
        };
        this.divRef = React.createRef();
        this.handleResize = this.handleResize.bind(this);
    }

    static propTypes = {
        title: PropTypes.string,
        toolTipText: PropTypes.string,
        tabs: PropTypes.element,
        previousPageTitle: PropTypes.string,
        previousPageUrl: PropTypes.string
    };

    state = {
        isChangingPassword: false,
        showProfile: false,
        showMinimizedProfile: false,
        selectedProfile: 'deselected',
        fontSize: '24',
    }

    handleLanguageChange = event => {
        this.context.setLanguage(event.target.value);
        moment.locale(event.target.value);
        this.props.postData(`/api/portal/uiLanguage/Set?uiLanguage=${event.target.value}`)
    }

    handleLogoutMenuClick = e => {
        //this.setState({ isLoggingOut: true });
        this.context.logout();
    };

    handleChangePassword = e => {
        this.setState({ isChangingPassword: true });
    }

    toggleProfileMenu = () => {
        this.setState((prevState) => ({
            showProfile: !prevState.showProfile,
            selectedProfile: this.state.showProfile ? "deselected" : "selected"
        }));
    }
    showProfileMenu = () => {
        this.setState({ showProfile: true });
    }
    hideProfileMenu = () => {
        this.setState({ showProfile: false });
    }
    // handleToggleProfileMenu = () => {

    //     this.setState({showProfile: !this.state.showProfile});
    // };

    handleDeselect = () => {
        if (this.state.selectedProfile !== "selected") {
            this.setState({ selectedProfile: "deselected" });
        }
    }
    handleSelect = () => {
        if (this.state.selectedProfile !== "selected") {
            this.setState({ selectedProfile: "hover" });
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
        //console.log(this.context.state.uiLanguage)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.uiLanguage !== this.props.uiLanguage) {
            this.handleResize();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
        const divElement = this.divRef.current;
        if (divElement) {
            const width = window.innerWidth;
            const length = divElement.innerHTML.length;
            // Adjust this factor as needed 
            //currently hardcoded for en and fr, but if more languages are added, each needs a new coef

            const coef = (this.props.uiLanguage === "fr") ? .85 : .85;
            const newSize = Math.min(24, coef * (width - 20) / length);
            this.setState({ fontSize: newSize });
            if (window.innerWidth < 992) {
                this.setState({ showMinimizedProfile: true })
            }
            else {
                this.setState({ showMinimizedProfile: false })
            }
        }
    };


    render() {

        // if NOT social login, then we need to render the "change password" link
        //const isSocialLogin = isSocialLogin(this.context.state.subjectClaim);

        const subjectClaim = this.context.state.subjectClaim;
        let showChangePassword = false;
        if (!isEmpty(subjectClaim)) {
            showChangePassword = !isSocialLogin(this.context.state.subjectClaim);
        }


        if (this.state.isChangingPassword) {
            return <Redirect to="/change-password" />;
        }

        const popupClass = this.state.showProfile ? 'visible' : '';
        const selectedClass = this.state.selectedProfile;


        //let flyoutClass = this.state.profileDropdownOpen ? "" : "hidden";
        //let iconArrow = this.state.profileDropdownOpen
        //    ? "icon-arrowup.png"
        //    : "icon-arrowdown.png";

        let iconAvatar = "";
        if (this.context.state.profile) {
            iconAvatar = this.context.state.profile.picture;
        }

        //<div
        //    className="profile"
        //    onClick={this.toggleProfileMenu}
        //    onMouseOver={this.showProfileMenu}
        //    onMouseOut={this.hideProfileMenu}
        //>
        //<div className={`popup ${popupClass}`} onMouseOut={this.hideProfileMenu}>
        //    <ul>
        //        <li onClick={this.handleLogoutMenuClick}>{this.handleChangePassword}>{this.props.returnLocalizedString("m0456")}</li>
        //        {showChangePassword && <li onClick={this.handleChangePassword}>{this.handleChangePassword}>{this.props.returnLocalizedString("m0119")}</li>}
        //    </ul>
        //</div>

        //!DBTRANS! @m0119@ Change Password !DEVNOTE! Profile Option
        //!DBTRANS! @m0456@ Log Out !DEVNOTE! Profile Option

        return (
            <AppContext.Consumer>
                {context => (
                    <section className="page-head">


                        <div className="toolbar">
                            <span className="nav-controls" >
                                <div className="title-container" >
                                    {this.props.tabs && <div className="title-breadcrumbs" >{this.props.tabs}</div>}

                                    <div style={{ display: 'flex' }}>
                                        {
                                            isEmpty(this.props.previousPageTitle) && (
                                                <h1 className="title" ref={this.divRef} style={{ fontSize: `${this.state.fontSize}px` }} >{this.props.title}</h1>
                                            )
                                        }
                                        {
                                            !isEmpty(this.props.previousPageTitle) && isEmpty(this.props.previousPageUrl) && (
                                                <h1 className="title" ref={this.divRef} style={{ fontSize: `${this.state.fontSize}px` }}>${this.props.previousPageTitle}&nbsp;&rsaquo;&nbsp;${this.props.title}</h1>
                                            )
                                        }
                                        {
                                            !isEmpty(this.props.previousPageTitle) && !isEmpty(this.props.previousPageUrl) && (
                                                <h1 className="title" ref={this.divRef} style={{ fontSize: `${this.state.fontSize}px` }}>
                                                    <Link className="title" to={this.props.previousPageUrl}>{this.props.previousPageTitle}</Link>
                                                    &nbsp;&rsaquo;&nbsp;{this.props.title}
                                                </h1>
                                            )
                                        }
                                        {
                                            !isEmpty(this.props.toolTipText) && (

                                                <Tooltip mode="light" tip={this.props.toolTipText} marginLeft={10} />

                                            )
                                        }
                                    </div>

                                </div>
                                <div className="profile-container" style={{ width: this.state.showMinimizedProfile ? 50 : 300 }}>
                                    {!this.state.showMinimizedProfile && <div className="language-dropdown">
                                        <DropDownList
                                            data={languages}
                                            value={context.state.uiLanguage}
                                            defaultValue={context.state.uiLanguage}
                                            onChange={this.handleLanguageChange}
                                            style={{ width: "50px" }}
                                        />
                                    </div>}
                                    <div className="profile" style={{ width: this.state.showMinimizedProfile ? 36 : 200 }}>
                                        <div className={`${selectedClass}`} >
                                            <img className="avatar" src={iconAvatar} alt="" onClick={this.toggleProfileMenu} onMouseOver={this.handleSelect} onMouseOut={this.handleDeselect} />
                                        </div>
                                        {!this.state.showMinimizedProfile && <div className="userName" onClick={this.toggleProfileMenu} onMouseOver={this.handleSelect} onMouseOut={this.handleDeselect}>
                                            {context.state.userName}
                                            <span className="k-icon k-i-arrow-s"
                                            ></span>
                                        </div>}

                                        <div className={`popup ${popupClass}`} >
                                            <ul>
                                                {this.state.showMinimizedProfile &&
                                                    <div className="popupProfileContainer" style={{ flexDirection: "row", display: "flex" }}>
                                                        <img className="avatar" src={iconAvatar} alt="" />
                                                        <div className='popupUserName'>{context.state.userName}:</div>
                                                    </div>
                                                }

                                                <li onClick={this.handleLogoutMenuClick}>{this.props.returnLocalizedString("m0456")}</li>
                                                {showChangePassword && <li onClick={this.handleChangePassword}>{this.props.returnLocalizedString("m0119")}</li>}
                                            </ul>
                                            {this.state.showMinimizedProfile &&
                                                <DropDownList
                                                    data={languages}
                                                    value={context.state.uiLanguage}
                                                    defaultValue={context.state.uiLanguage}
                                                    onClick={this.showProfileMenu}
                                                    onChange={this.handleLanguageChange}
                                                    style={{ width: "50px", marginLeft: "2.5px" }}
                                                />}
                                        </div>
                                    </div>
                                </div>
                            </span>

                            {this.props.children}
                        </div>
                    </section>
                )}
            </AppContext.Consumer>
        );
    }
}
Header.contextType = AppContext;
export default compose(hasData, localize)(Header);


// WEBPACK FOOTER //
// ./src/components/Header.js